import { TFunction } from "i18next";
import { InferType, array, object, string } from "yup";


export const EtablissementFilterValidationSchema = (t: TFunction) => {
  return object({
    metierFilter: string().required(t("form.required")),
    villeFilter: string().required(t("form.required")),
    typeEtablissement: string(),
    disponibilitesFilter: array().of(string().defined()),
  });

}
export type EtablissementFilterValidationType = InferType<
  ReturnType<typeof EtablissementFilterValidationSchema>
>;
